import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/auth.slice";
import itemsReducer from "./items/items.slice";
import usersReducer from "./users/users.slice";

export function createAppStore() {
  return configureStore({
    reducer: {
      auth: authReducer,
      items: itemsReducer,
      users: usersReducer,
    },
  });
}

export const store = createAppStore();

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
